module.exports = __webpack_public_path__ + "img/insta-5.4a3bf357.jpg";